<template>
  <div class="tile is-parent">
    <article class="tile is-child box">
      <div class="block">
        <router-link class="button is-info" :to="{name:'topicCategorieEdit'}">新增专题分类</router-link>
      </div>
      <table class="table is-bordered">
        <thead>
        <tr>
          <td>分类Id</td>
          <td>分类图</td>
          <td>分类名称</td>
          <td>状态</td>
          <td>备注</td>
          <td>设置</td>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item,index) in TopicCategoryList">
          <td>{{item.categoryId}}</td>
          <td>
            <image-component :image="item.image" :width="200" :compress="1.2"></image-component>
          </td>
          <td>{{item.name}}</td>
          <td>
            <span v-if="item.status == 1" class="button is-success">开启</span>
            <span v-else class="button is-danger">关闭</span>
          </td>
          <td>{{item.remark}}</td>
          <td><router-link class="button is-info" :to="{name:'topicCategorieEdit',query:{categoryId:item.categoryId}}">编辑</router-link></td>
        </tr>
        </tbody>
      </table>
    </article>
  </div>
</template>
<script type="text/babel">
  export default {
    data(){
      return {
        TopicCategoryList:[],
        count:0,
        page:0
      }
    },
    created(){
      this.getTopicCategoryList()
    },
    methods: {
      getTopicCategoryList(){
        HttpRequest.post("/admin.php?method=blogger.getTopicCategoryList",{page:this.page}, true).then((response) => {
          this.TopicCategoryList = response.data.list;
        }, (response) => {

        });
      }
    }
  }
</script>
<style lang="less">
  .category-img{
    height: 200px;
  }
</style>
